import { onUnmounted } from 'vue'

export const useGlobalKeyListener = () => {
  const callbacks: Map<string, () => void> = new Map()

  const onKey = (key: string, callback: () => void) => {
    callbacks.set(key, callback)
  }

  const removeKey = (key: string) => {
    callbacks.delete(key)
  }

  const listenToKey = (event: KeyboardEvent) => {
    if (!targetShouldBeIgnored(event.target)) {
      if (callbacks.has(event.key)) {
        callbacks.get(event.key)!()
      }
    }
  }

  const targetShouldBeIgnored = (target: EventTarget | null): boolean => {
    if (target instanceof HTMLElement) {
      const tagName = target.tagName.toLowerCase()
      return (
        tagName == 'textarea' ||
        tagName == 'input' ||
        tagName == 'select' ||
        target.classList.contains('tiptap')
      )
    }

    return false
  }

  document.addEventListener('keyup', listenToKey)

  onUnmounted(() => {
    document.removeEventListener('keyup', listenToKey)
  })

  return { onKey, removeKey }
}
